import React from "react";
// import Home from "../page/Home";
// import Cart from "../page/Cart";
// import Products from "./page/Products";
// import SingelProducts from "../page/SingelProducts";
// import Shop from "../page/Shop";
// import SubCategories from "../component/SubCategories";
// import Login from "../page/Login";
// import Search from "../page/Search";
// import About from "../ourPolicy/About";
// import RedirectOldProductUrl from "../component/RedirectOldProductUrl";
// import HoleSale from "../page/HoleSale";
// import Contact from "../ourPolicy/Contact";
// import TermCondition from "../ourPolicy/Term&Condition";
// import ShippingPolicy from "../ourPolicy/ShippingPolicy";
// import PrivacyPolicy from "../ourPolicy/PrivacyPolicy";
// import Checkout from "../page/Checkout";
// import Profile from "../page/Profile";
// import Order from "../MyOrders/order";
// import Address from "../MyAddress/newAddress";
// import OrderPlaced from "../page/OrderPlaced";
// import PageNotFound from "../page/PageNotFound";
// import OurStore from "../page/OurStore";

const Home = React.lazy(() => import("../page/Home"));
const SingelProducts = React.lazy(() => import("../page/SingelProducts"));
const Shop = React.lazy(() => import("../page/Shop"));
const SubCategories = React.lazy(() => import("../component/SubCategories"));
const Login = React.lazy(() => import("../page/Login"));
const Search = React.lazy(() => import("../page/Search"));
const About = React.lazy(() => import("../ourPolicy/About"));
const Contact = React.lazy(() => import("../ourPolicy/Contact"));
const TermCondition = React.lazy(() => import("../ourPolicy/Term&Condition"));
const ShippingPolicy = React.lazy(() => import("../ourPolicy/ShippingPolicy"));
const PrivacyPolicy = React.lazy(() => import("../ourPolicy/PrivacyPolicy"));
const Checkout = React.lazy(() => import("../page/Checkout"));
const Profile = React.lazy(() => import("../page/Profile"));
const Order = React.lazy(() => import("../MyOrders/order"));
const Address = React.lazy(() => import("../MyAddress/newAddress"));
const OrderPlaced = React.lazy(() => import("../page/OrderPlaced"));
const PageNotFound = React.lazy(() => import("../page/PageNotFound"));
const HoleSale = React.lazy(() => import("../page/HoleSale"));
const RedirectOldProductUrl = React.lazy(() => import("../component/RedirectOldProductUrl"));
const OurStore = React.lazy(() => import("../page/OurStore"));
const FAQ = React.lazy(() => import("../page/Faq"));
const AllCategories = React.lazy(() => import("../page/AllCategories"));

const route = [
    { path: "/", component: Home },
    { path: "/categories", component: AllCategories },
    { path: "/grocery/:id/:itemName", component: Shop },
    { path: "/product/:id/:itemName", component: SingelProducts },
    // { path: "/category/:id/:itemName", component: SubCategories },
    { path: "/category/:id/:itemName/:subcategoryId/:subcategoryName", component: SubCategories },
    { path: "/login", component: Login },
    { path: "/search", component: Search },
    { path: "/about", component: About },
    { path: "/contact", component: Contact },
    { path: "/term&Condition", component: TermCondition },
    { path: "/shipping&refundPolicy", component: ShippingPolicy },
    { path: "/Privacy-Policy", component: PrivacyPolicy },
    { path: "/checkout/:id", component: Checkout, protected: true },
    { path: "/profile", component: Profile, protected: true },
    { path: "/orders", component: Order, protected: true },
    { path: "/OrderPlaced/:id", component: OrderPlaced, protected: true },
    { path: "/address", component: Address, protected: true },
    { path: "/Khari-Baoli-Dry-Fruits-Rate-List-Today", component: HoleSale },
    { path: "/product-details.php", component: RedirectOldProductUrl },
    { path: "/store", component: OurStore },
    { path: "/FAQ", component: FAQ },
    { path: "*", component: PageNotFound }
  ];
  
  export default route;